import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  textTitle: {
    color: theme.palette.BlueDownDark,
    fontSize: theme.spacing(2),
    fontWeight: theme.spacing(75),
  },
  textColor: {
    color: theme.palette.BlueDownDark,
    fontSize: theme.spacing(2),
  },
  text: {
    fontSize: theme.spacing(1.8),
  },
}))
export default styles
